export function handleFileSelect(event, type, setImagePreviewUrl, setSelectedFiles, setEditItem) {
  event.preventDefault();
  const file = event.target.files[0];
  if (!file) return;
  if (!validateFile(file, type)) return;

  if (type === "image") {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreviewUrl(e.target.result);
      setSelectedFiles((prev) => ({ ...prev, image: file }));
      setEditItem((prev) => ({ ...prev, image: file.name }));
    };
    reader.readAsDataURL(file);
  } else if (type === "audio") {
    setSelectedFiles((prev) => ({ ...prev, audio: file }));
    setEditItem((prev) => ({ ...prev, path: file.name }));
  }
}

export function validateFile(file, type) {
  if (file.size > 10 * 1024 * 1024) {
    alert("파일 크기는 10MB를 초과할 수 없습니다.");
    return false;
  }
  
  if (type === "image") {
    if (!file.type.startsWith("image/")) {
      alert("이미지 파일만 업로드 가능합니다.");
      return false;
    }
  } else if (type === "audio") {
    const validAudioTypes = [
      "audio/mpeg",     // MP3
      "audio/mp3",      // MP3 (alternative)
      "audio/wav",      // WAV
      "audio/wave",     // WAV (alternative)
      "audio/aac",      // AAC
      "audio/mp4",      // M4A/AAC in MP4 container
      "audio/ogg",      // OGG
      "audio/flac",     // FLAC
      "audio/webm",     // WebM audio
      "audio/x-m4a",    // M4A (alternative)
    ];
    
    const validExtensions = [".mp3", ".wav", ".aac", ".m4a", ".ogg", ".flac"];
    const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
    
    const isValidType = file.type.startsWith("audio/") || validAudioTypes.includes(file.type);
    const isValidExtension = validExtensions.includes(fileExtension);
    
    if (!isValidType && !isValidExtension) {
      alert("지원되는 음원 파일만 업로드 가능합니다. (MP3, WAV, AAC, M4A, OGG, FLAC)");
      return false;
    }
  }
  
  return true;
}

export function handleImagePreview(file, setImagePreviewUrl) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreviewUrl(e.target.result);
      resolve();
    };
    reader.readAsDataURL(file);
  });
}

export function resetFileInput(input, type, setImagePreviewUrl, setEditItem, setSelectedFiles) {
  input.value = "";
  if (type === "image") {
    setImagePreviewUrl("");
    setEditItem((prev) => ({ ...prev, image: "" }));
    setSelectedFiles((prev) => ({ ...prev, image: null }));
  } else {
    setEditItem((prev) => ({ ...prev, path: "" }));
    setSelectedFiles((prev) => ({ ...prev, audio: null }));
  }
} 